import { gql } from '@apollo/client';

export const UPSERT_FILING_STATUS_BY_FILING = gql`
  mutation UpsertFilingStatusByFiling($companyId: ID!, $filingId: ID!, $status: String!) {
    filingStatus_upsertByFiling(companyId: $companyId, filingId: $filingId, status: $status)
  }
`;
